export default "__VITE_ASSET__BVRjfRWW__"